export const SITE = {
  name: "MESCO Springs",
  fullName: "Modern Engineering and Spring Company",
  mainSite: "https://www.mescosprings.com",
  phone1: "+91 85549 85323",
  phone1Href: "tel:+918554985323",
  phone2: "+91 85549 37848",
  phone2Href: "tel:+918554937848",
  whatsapp:
    "https://wa.me/918554985323?text=Hello%20MESCO%20Springs%2C%20I%20have%20a%20spring%20requirement.",
  email: "marketing@mescosprings.com",
  address:
    "11, Sona Udyog Estate, Parsi Panchayat Road, Andheri East, Mumbai 400069, Maharashtra, India",
  youtube: "https://youtu.be/ONTUzptYxw0",
  youtubeEmbed: "https://www.youtube.com/embed/ONTUzptYxw0",
  tagline: "Absorb. Restore. Energize.",
};

export const IMAGES = {
  heroFactory: "https://mescosprings.in/wp-content/uploads/2025/11/DSC00854-scaled-1.webp",
  shopfloor1: "https://mescosprings.in/wp-content/uploads/2025/12/IMG_9254-scaled.jpg",
  shopfloor2: "https://mescosprings.in/wp-content/uploads/2026/05/DSC_0033-scaled.jpg",
  shopfloor3: "https://mescosprings.in/wp-content/uploads/2025/12/DSC00881-scaled.jpg",
  shopfloor4: "https://mescosprings.in/wp-content/uploads/2026/05/Misc.jpg",
  logo: "https://mescosprings.in/wp-content/uploads/2024/04/MESCO_LOGO_nobg.webp",
  steelTexture: "https://images.unsplash.com/photo-1695987196855-3770e1f1a100?q=80&w=1800&auto=format&fit=crop",
  metalBars: "https://images.unsplash.com/photo-1732305130486-15665abfdf92?q=80&w=1800&auto=format&fit=crop",
  heavyMachine: "https://images.pexels.com/photos/12951623/pexels-photo-12951623.jpeg?auto=compress&cs=tinysrgb&w=1800",
};
